<template>
  <div>
    <v-card>
      <v-card-title class="d-flex flex-wrap align-center">
        <div>
          <span>{{ $t('absences.title') }}</span>
          <div class="text-caption text--secondary">
            {{ $t('absences.subtitle') }}
          </div>
        </div>
        <v-spacer />
        <v-btn color="primary" depressed @click="hapFormen()">
          <v-icon left>mdi-calendar-plus</v-icon>
          {{ $t('absences.declare') }}
        </v-btn>
      </v-card-title>

      <v-tabs v-model="skeda" grow>
        <v-tab>{{ $t('absences.tab_upcoming') }}</v-tab>
        <v-tab>{{ $t('absences.tab_history') }}</v-tab>
      </v-tabs>

      <v-card-text v-if="skeda === 0" class="pb-0">
        <v-switch
          v-model="shfaqTeKaluarat"
          :label="$t('absences.show_all')"
          dense
          hide-details
          class="mt-0"
          @change="ngarko"
        />
      </v-card-text>

      <v-card-text v-else class="pb-0">
        <div class="text-caption text--secondary">
          {{ $t('absences.history_subtitle') }} ({{ $t('absences.last_6_months') }})
        </div>
      </v-card-text>

      <v-data-table
        v-if="skeda === 1"
        :headers="kolonatHistoriku"
        :items="historiku"
        :loading="historikuDuke"
        :no-data-text="$t('absences.no_history')"
        :items-per-page="25"
      >
        <template v-slot:item.source="{ item }">
          <v-chip x-small :color="item.source === 'parent' ? '#E8701E' : '#455A64'" text-color="white">
            {{ item.source === 'parent' ? $t('absences.by_parent') : $t('absences.by_driver') }}
          </v-chip>
          <span v-if="item.cancelled" class="text-caption text--secondary ml-1">
            ({{ $t('absences.withdrawn') }})
          </span>
        </template>

        <template v-slot:item.date="{ item }">
          <strong>{{ dataShkurt(item.date) }}</strong>
          <span v-if="item.to_date && item.to_date !== item.date">
            – <strong>{{ dataShkurt(item.to_date) }}</strong>
          </span>
          <div class="text-caption text--secondary">{{ dita(item.date) }}</div>
        </template>

        <template v-slot:item.at="{ item }">
          {{ item.at | moment('DD/MM/YYYY HH:mm') }}
          <div v-if="item.by" class="text-caption text--secondary">{{ item.by }}</div>
        </template>

        <template v-slot:item.bus="{ item }">
          {{ item.bus || '—' }}
        </template>
      </v-data-table>

      <v-data-table
        v-else
        :headers="kolonat"
        :items="mungesat"
        :loading="isLoading"
        :no-data-text="eshteShkolle ? $t('absences.none_school') : $t('absences.none')"
        :items-per-page="25"
      >
        <template v-slot:item.periudha="{ item }">
          <strong>{{ dataShkurt(item.from_date) }}</strong>
          <span v-if="item.to_date !== item.from_date">
            – <strong>{{ dataShkurt(item.to_date) }}</strong>
            <span class="text-caption text--secondary">
              ({{ numriIDiteve(item) }})
            </span>
          </span>
        </template>

        <template v-slot:item.reported="{ item }">
          <div>{{ item.reported_at | moment('DD/MM/YYYY HH:mm') }}</div>
          <div class="text-caption text--secondary">{{ item.reported_by }}</div>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip x-small :color="ngjyraEGjendjes(item)" text-color="white">
            {{ teksiIGjendjes(item) }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <!-- Pasi dita ka kaluar, lajmerimi mbetet si gjurme por nuk preket. -->
          <template v-if="item.editable">
            <v-btn icon small class="mr-1" @click="hapFormen(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small @click="terhiq(item)">
              <v-icon small color="error">mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
          <span v-else class="text-caption text--secondary">—</span>
        </template>
      </v-data-table>
    </v-card>

    <!-- Forma e lajmerimit -->
    <v-dialog v-model="formaHapur" max-width="520" persistent>
      <v-card>
        <v-card-title>
          {{ perNdryshim ? $t('absences.edit') : $t('absences.declare') }}
        </v-card-title>

        <v-card-text>
          <v-form ref="forma" v-model="formaVlefshme">
            <v-select
              v-if="perNdryshim"
              v-model="forma.student_id"
              :items="nxenesit"
              item-text="name"
              item-value="id"
              :label="$t('absences.student')"
              disabled
              outlined
              dense
            />

            <!-- Nje prind me dy femije qe mungojne te njejtat dite i zgjedh bashke. -->
            <v-select
              v-else
              v-model="forma.student_ids"
              :items="nxenesit"
              item-text="name"
              item-value="id"
              :label="$t('absences.students')"
              :rules="[v => (v && v.length > 0) || $t('forms.required')]"
              multiple
              chips
              small-chips
              deletable-chips
              outlined
              dense
            />

            <v-menu v-model="menuNga" :close-on-content-click="false" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  :value="dataShkurt(forma.from_date)"
                  :label="$t('absences.from_date')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  :rules="[v => !!v || $t('forms.required')]"
                />
              </template>
              <v-date-picker
                v-model="forma.from_date"
                :min="sot"
                first-day-of-week="1"
                @input="zgjodhaNga"
              />
            </v-menu>

            <v-checkbox
              v-model="vetemNjeDite"
              :label="$t('absences.one_day')"
              dense
              hide-details
              class="mt-0 mb-3"
              @change="njeDiteNdryshoi"
            />

            <v-menu
              v-if="!vetemNjeDite"
              v-model="menuDeri"
              :close-on-content-click="false"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  :value="dataShkurt(forma.to_date)"
                  :label="$t('absences.to_date')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                />
              </template>
              <v-date-picker
                v-model="forma.to_date"
                :min="forma.from_date || sot"
                first-day-of-week="1"
                @input="menuDeri = false"
              />
            </v-menu>

            <v-text-field
              v-model.trim="forma.reason"
              :label="$t('absences.reason')"
              maxlength="255"
              outlined
              dense
            />

            <v-alert v-if="gabimi" dense text type="error" class="mb-0">
              {{ gabimi }}
            </v-alert>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="duke" @click="formaHapur = false">
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn color="primary" depressed :loading="duke" @click="ruaj">
            {{ $t('actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Mungesat e lajmeruara paraprakisht.
 *
 * E njejta faqe sherben prindin dhe shkollen: serveri vendos cilet nxenes i
 * takojne perdoruesit, ndaj ketu nuk ka asnje kontroll te dyte te te drejtave.
 */
import axios from 'axios';
import { mesazhiIGabimit } from '@/utils/error-message';

export default {
  data() {
    return {
      isLoading: false,
      mungesat: [],
      nxenesit: [],
      shfaqTeKaluarat: false,
      skeda: 0,
      historiku: [],
      historikuDuke: false,

      formaHapur: false,
      formaVlefshme: false,
      perNdryshim: null,
      duke: false,
      gabimi: '',
      menuNga: false,
      menuDeri: false,
      vetemNjeDite: true,
      forma: { student_id: null, student_ids: [], from_date: '', to_date: '', reason: '' },
    };
  },

  computed: {
    sot() {
      return new Date().toLocaleDateString('en-CA');
    },

    eshteShkolle() {
      const rol = localStorage.getItem('userRole');
      return rol === '2' || rol === '7';
    },

    kolonat() {
      const k = [{ text: this.$t('absences.student'), value: 'student_name' }];

      k.push(
        { text: this.$t('absences.period'), value: 'periudha', sortable: false },
        { text: this.$t('absences.reason'), value: 'reason' },
        { text: this.$t('absences.reported'), value: 'reported' },
        { text: this.$t('absences.status'), value: 'status', sortable: false },
        { text: this.$t('absences.actions'), value: 'actions', sortable: false },
      );

      return k;
    },

    kolonatHistoriku() {
      return [
        { text: this.$t('absences.student'), value: 'student_name' },
        { text: this.$t('absences.date'), value: 'date' },
        { text: this.$t('absences.source'), value: 'source', sortable: false },
        { text: this.$t('absences.reason'), value: 'reason' },
        { text: this.$t('absences.bus'), value: 'bus', sortable: false },
        { text: this.$t('absences.reported'), value: 'at' },
      ]
    },
  },

  watch: {
    // Historiku merret vetem kur hapet skeda e tij.
    skeda(e_re) {
      if (e_re === 1 && !this.historiku.length) this.ngarkoHistorikun()
    },
  },

  mounted() {
    this.ngarko();
    this.ngarkoNxenesit();
  },

  methods: {
    dataShkurt(v) {
      return v ? this.$moment(v).format('DD/MM/YYYY') : '';
    },

    numriIDiteve(item) {
      const d = this.$moment(item.to_date).diff(this.$moment(item.from_date), 'days') + 1;
      return `${d} ${this.$t('absences.days')}`;
    },

    ngjyraEGjendjes(item) {
      // Ngjyra te shkruara: klasat me emer te Vuetify-t hiqen nga ndertimi
      // kur dalin vetem ketu, dhe etiketa mbetej e bardhe mbi te bardhe.
      if (item.cancelled_at) return '#9E9E9E';
      return item.editable ? '#43A047' : '#757575';
    },

    teksiIGjendjes(item) {
      if (item.cancelled_at) return this.$t('absences.withdrawn');
      return item.editable ? this.$t('absences.active') : this.$t('absences.past');
    },

    /** Emri i dites, qe prindi ta njohe diten pa llogaritur daten. */
    dita(v) {
      return v ? this.$moment(v).format('dddd') : '';
    },

    async ngarkoHistorikun() {
      this.historikuDuke = true;
      try {
        const { data } = await axios.get('/student-absences/history');
        this.historiku = data;
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.historikuDuke = false;
      }
    },

    async ngarko() {
      this.isLoading = true;
      try {
        // Pa interval serveri kthen vetem ato qe ende nuk kane mbaruar.
        const params = this.shfaqTeKaluarat
          ? { from: this.$moment().subtract(6, 'months').format('YYYY-MM-DD'), to: this.$moment().add(1, 'year').format('YYYY-MM-DD') }
          : {};
        const { data } = await axios.get('/student-absences', { params });
        this.mungesat = data;
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.isLoading = false;
      }
    },

    /** Lista e nxenesve per te cilet perdoruesi mund te lajmeroje. */
    async ngarkoNxenesit() {
      try {
        const url = this.eshteShkolle ? '/users/all-students-list' : '/users/guardian-students/list';
        const { data } = await axios.get(url);
        const lista = Array.isArray(data) ? data : data?.data ?? [];
        this.nxenesit = lista.map((s) => ({ id: s.id ?? s.student_id, name: s.name }));
      } catch (e) {
        this.nxenesit = [];
      }
    },

    hapFormen(item = null) {
      this.perNdryshim = item;
      this.gabimi = '';

      if (item) {
        this.forma = {
          student_id: item.student_id,
          student_ids: [item.student_id],
          from_date: item.from_date,
          to_date: item.to_date,
          reason: item.reason || '',
        };
        this.vetemNjeDite = item.from_date === item.to_date;
      } else {
        this.forma = {
          student_id: null,
          // Nje femije i vetem zgjidhet paraprakisht: prindi me nje femije
          // nuk duhet te klikoje kot.
          student_ids: this.nxenesit.length === 1 ? [this.nxenesit[0].id] : [],
          from_date: this.sot,
          to_date: this.sot,
          reason: '',
        };
        this.vetemNjeDite = true;
      }

      this.formaHapur = true;
      this.$nextTick(() => this.$refs.forma && this.$refs.forma.resetValidation());
    },

    zgjodhaNga() {
      this.menuNga = false;
      // Nje date fundi me e hershme se fillimi nuk ka kuptim.
      if (this.vetemNjeDite || !this.forma.to_date || this.forma.to_date < this.forma.from_date) {
        this.forma.to_date = this.forma.from_date;
      }
    },

    njeDiteNdryshoi() {
      if (this.vetemNjeDite) this.forma.to_date = this.forma.from_date;
    },

    async ruaj() {
      if (this.$refs.forma && !this.$refs.forma.validate()) return;

      this.gabimi = '';
      this.duke = true;

      const trupi = {
        from_date: this.forma.from_date,
        to_date: this.vetemNjeDite ? this.forma.from_date : this.forma.to_date,
        reason: this.forma.reason || null,
      };

      try {
        if (this.perNdryshim) {
          await axios.put(`/student-absences/${this.perNdryshim.id}`, trupi);
          this.$notify({ title: 'OK', text: this.$t('absences.updated'), type: 'success' });
        } else {
          const { data } = await axios.post('/student-absences', {
            ...trupi,
            student_ids: this.forma.student_ids,
          });
          this.$notify({
            title: 'OK',
            text: data.message || this.$t('absences.saved'),
            type: 'success',
          });
        }
        this.formaHapur = false;
        this.historiku = [];
        this.ngarko();
      } catch (e) {
        this.gabimi = mesazhiIGabimit(e);
      } finally {
        this.duke = false;
      }
    },

    async terhiq(item) {
      const rezultati = await this.$swal({
        title: this.$t('absences.withdraw'),
        text: this.$t('absences.withdraw_confirm'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('absences.withdraw'),
        cancelButtonText: this.$t('actions.cancel'),
      });
      if (!rezultati.isConfirmed) return;

      try {
        await axios.delete(`/student-absences/${item.id}`);
        this.$notify({ title: 'OK', text: this.$t('absences.cancelled'), type: 'success' });
        this.ngarko();
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      }
    },
  },
};
</script>

<style scoped>
/* Vuetify i jep .v-card__title 'word-break: break-all', qe i ndan fjalet
   ne mes: 'udhëtojë' dilte 'udh ëtojë'. Ketu thyhet vetem midis fjaleve. */
::v-deep .v-card__title,
::v-deep .v-card__title * {
  word-break: normal;
  overflow-wrap: break-word;
}
</style>
